import React from "react";
import { useNavigate } from "react-router-dom";
import "../Css/FoundationHero.css";
import bg from "../assets/gallery2.webp";
import gallery from "../assets/gallery3.webp";
import group from "../assets/group.jpg";
const FoundationHero = () => {
  const navigate = useNavigate();

  return (
    <>
    <section
      className="foundation-hero"
      style={{ backgroundImage: `url(${bg})` }}
    >
      <div className="foundation-overlay"></div>

      <div className="foundation-container">
        <div className="foundation-card">
          <span className="foundation-tag">
            Strong Concepts • Class 11 & 12 Science
          </span>

          <h1>Class 11 & 12 Science Foundation</h1>

          <p>
            Class <strong>11th and 12th Science</strong> are the most crucial
            years for students preparing for
            <strong> Boards, JEE, and NEET</strong>.
            <strong> IITian’s Chinmay Academy</strong> provides a strong
            foundation program focused on deep concept clarity and exam
            readiness.
          </p>

          <p>
            Our expert faculty offers
            <strong> personalized one-to-one guidance</strong> in
            <strong> Physics, Chemistry, Mathematics / Biology</strong>,
            ensuring NCERT mastery, numerical practice, and strategic
            preparation for competitive exams.
          </p>

          <button
            className="foundation-btn"
            onClick={() => navigate("/contact")}
          >
            Enquire Now
          </button>
        </div>
      </div>
    </section>

        <section className="science-info-section">
  <div className="science-info-container">

    {/* LEFT CONTENT */}
    <div className="science-info-content">
      <h2>
        12th Science Coaching in Vadodara <br />
        <span>Academic Year 2025–2026</span>
      </h2>

      <p className="intro">
        The <strong>12th grade</strong> is the final and most crucial year for
        Science students, determining success in
        <strong> Board Exams</strong> and competitive entrance tests such as
        <strong> JEE, NEET, and GUJCET</strong>.
        At <strong>IITian’s Chinmay Academy</strong>, we provide a
        structured and result-oriented coaching approach for the
        <strong> 2025–2026 academic year</strong>.
      </p>

      <h3>Understanding the Competitive Landscape (2025–2026)</h3>

      <ul className="science-info-points">
        <li>
          <strong>Rising Number of Aspirants –</strong>
          Increased interest in Science streams has significantly raised
          competition at both board and entrance levels.
        </li>

        <li>
          <strong>Multiple Exam Formats –</strong>
          Students must prepare for boards while simultaneously handling
          competitive exams like JEE, NEET, and GUJCET.
        </li>

        <li>
          <strong>Concept-Based Learning –</strong>
          Exams now focus on application-based questions, making
          strong conceptual understanding essential.
        </li>

        <li>
          <strong>State & National-Level Challenges –</strong>
          Along with national exams, state-level tests such as GUJCET
          require targeted preparation strategies.
        </li>
      </ul>

      <p className="closing">
        At <strong>IITian’s Chinmay Academy</strong>, our
        <strong> 12th Science coaching program</strong> combines IITian-led
        mentorship, personalized guidance, regular assessments, and
        exam-focused strategies to help students achieve outstanding
        results with confidence.
      </p>
    </div>

    {/* RIGHT IMAGE */}
    <div className="science-info-image">
      <img src={gallery} alt="12th Science Classroom" />
    </div>

  </div>
</section>

        <section className="course-highlights">
  <h2 className="section-title">Course Highlights</h2>

  <div className="highlights-container">
    {/* Card 1 */}
    <div className="highlight-card">
      <div className="icon-circle">
        📚
      </div>
      <h3>Comprehensive Subject Coverage</h3>
      <p>
        In-depth coverage of <strong>Physics, Chemistry, and Mathematics</strong>
        aligned with <strong>CBSE / GSEB curriculum</strong> to ensure strong
        fundamentals and board exam readiness.
      </p>
    </div>

    {/* Card 2 */}
    <div className="highlight-card">
      <div className="icon-circle">
        🎯
      </div>
      <h3>Competitive Exam Modules</h3>
      <p>
        Intensive preparation modules for
        <strong> JEE Main, JEE Advanced, BITSAT</strong> and other engineering
        entrance examinations.
      </p>
    </div>

    {/* Card 3 */}
    <div className="highlight-card">
      <div className="icon-circle">
        ❓
      </div>
      <h3>Doubt Clearing Sessions</h3>
      <p>
        Regular <strong>doubt-solving and revision sessions</strong> to strengthen
        conceptual clarity and boost student confidence.
      </p>
    </div>

    {/* Card 4 */}
    <div className="highlight-card">
      <div className="icon-circle">
        📝
      </div>
      <h3>Frequent Testing</h3>
      <p>
        Chapter-wise tests, periodic assessments, and
        <strong> mock exams</strong> to track performance and improve results.
      </p>
    </div>
  </div>
</section>

        <section className="jee-guide-section">
  <div className="jee-guide-container">

    {/* LEFT CONTENT */}
    <div className="jee-guide-content">
      <h2>
        A Complete Guide to Class 11 & 12 Science Preparation
      </h2>

      <p>
        <strong>Class 11 and Class 12 Science</strong> form the foundation for
        success in <strong>Board Exams</strong> as well as competitive entrance
        tests like <strong>JEE, NEET, and GUJCET</strong>. These two years demand
        strong conceptual clarity, disciplined study habits, and a structured
        preparation strategy.
      </p>

      <p>
        At <strong>IITian’s Chinmay Academy</strong>, we help students and
        parents understand the right approach to managing the vast syllabus,
        balancing school academics with competitive exam preparation, and
        developing problem-solving skills essential for high performance in
        both boards and entrance examinations.
      </p>
    </div>

    {/* RIGHT IMAGE */}
    <div className="jee-guide-image">
      <img src={group} alt="Class 11 and 12 Science Students" />
    </div>

  </div>
</section>

<section className="how-it-works">
  <div className="how-container">

    <h2 className="how-title">How It Works</h2>

    <div className="how-content">
      <p>
        Booking <strong>IITian's Academy</strong> with <strong>IITian's Chinmay Academy</strong> is simple
        and hassle-free. In just three easy steps, your child gets access to
        expert IITian mentors and personalised learning at home.
      </p>

      <ul className="how-steps">
        <li>
          <strong>Step 1:</strong> Fill out the online registration form with your
          child’s academic requirements.
        </li>
        <li>
          <strong>Step 2:</strong> We match you with an experienced IITian tutor
          best suited for JEE preparation.
        </li>
        <li>
          <strong>Step 3:</strong> Schedule sessions and begin focused,
          one-to-one learning at home.
        </li>
      </ul>
    </div>

    {/* CALL TO ACTION */}
    <div className="how-call-box">
      <h3>Give Us a Call</h3>
      <p>
        Speak directly with our academic experts to discuss your child’s JEE
        preparation needs.
      </p>

      <a href="tel:+918849189845" className="how-call-btn">
        📞 +91 8849189845
      </a>
    </div>

  </div>
</section>

    </>
  );
};

export default FoundationHero;
